import React, { Fragment, useEffect, useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./styles.css";

const PhoneNumberInput = (props) => {
  const [defaultCountry, setDefaultCountry] = useState("");
  const { id, onChangeHandler, value, label, disabled } = props;
  const styleProps = {
    backgroundColor: "#FFFFFF",
    border: "1px solid #F1F1F1",
    borderRadius: "12px",
  };

  useEffect(() => {
    const userLocationInfo = JSON.parse(localStorage.getItem("ip-info"));
    if (userLocationInfo) {
      const { countryCode } = userLocationInfo;
      setDefaultCountry(countryCode);
    }
  }, []);

  return (
    <Fragment>
      <PhoneInput
        id={label}
        className="sapphire-phone-number-input"
        style={{ ...styleProps }}
        international
        defaultCountry={defaultCountry}
        value={value}
        onChange={(number) => onChangeHandler(number, id)}
        onCountryChange={(e) => e}
        disabled={disabled}
      />
    </Fragment>
  );
};

export default PhoneNumberInput;
